module.exports = __webpack_public_path__ + "static/media/mode-27.e472efad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-27.svg
// module id = 1000
// module chunks = 2